export default "__VITE_ASSET__DK9_jKqs__"